import script from "./CancelAccountCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelAccountCard.vue?vue&type=script&setup=true&lang=js"

import "./CancelAccountCard.vue?vue&type=style&index=0&id=53804c56&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53804c56"]])

export default __exports__